// extracted by mini-css-extract-plugin
export default {"manage-payment-accounts":"manage-payment-accountsaaXDY","managePaymentAccounts":"manage-payment-accountsaaXDY"};